/**
 * @generated SignedSource<<a0301c71227fb1fae462d7ae79c28a9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingHeaderFragment_BookingSummary$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
  readonly " $fragmentType": "BookingHeaderFragment_BookingSummary";
};
export type BookingHeaderFragment_BookingSummary$key = {
  readonly " $data"?: BookingHeaderFragment_BookingSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingHeaderFragment_BookingSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingHeaderFragment_BookingSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClubLogo_Club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "ce900f754aa62f8d6e7692ab7ec1a2d4";

export default node;
